<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules"
    >
        <CForm @submit.prevent>
            <CSelect 
                :value.sync="model.type"
                :horizontal="true"
                :options="types"
                label="Тип"
                placeholder="Тип"
                :is-valid="errors.type && errors.type.isValid" />
            <CInput
                v-model="model.title"
                horizontal
                label="Вопрос"
                placeholder="Вопрос"
                :is-valid="errors.title && errors.title.isValid"
            />
            <CTextarea
                v-model="model.description"
                horizontal
                label="Описание"
                placeholder="Описание"
            />

            <CRow form class="form-group">
                <CCol tag="label" class="col-form-label" sm="3">Фон вопроса</CCol>
                <CCol sm="9">
                    <div class="mb-2" v-if="model.background">
                        <img :src="imageUrl(model.background)" style="max-width:200px;" />
                    </div>
                    <input type="file" @change="onFileChange($event, 'background')" class="form-control-file" />
                </CCol>
            </CRow>

            
        
            <CCard v-if="model && (model.type === 'single' || model.type === 'multiple')">
                <CCardBody>
                    <div class="flex flex-row-reverse">
                        <CButton
                            color="primary"
                            class="mb-2"
                            @click="addVariant"
                        >Создать</CButton>
                    </div>
                    <CRow>
                        <CCol>
                            <table class="table">
                                <thead>
                                    <th></th>
                                    <th>Вариант</th>
                                    <th></th>
                                </thead>
                                <component
                                    :is="'draggable'"
                                    v-model="variants"
                                    tag="tbody">
                                    <tr v-for="(item, index) in variants" :key="item.id">
                                        <td class="p-1">
                                            <CIcon
                                                :height="24"
                                                :content="$options.icons.cilCursorMove"
                                                class="cursor-pointer"
                                            />
                                        </td>
                                        <td class="p-1">
                                            <CInput
                                                class="m-0"
                                                v-model="item.title"
                                                horizontal
                                                hide-details
                                            />
                                        </td>
                                        <td class="p-1">
                                            <div @click="removeVariant(index)">
                                                <CIcon
                                                    :height="20"
                                                    :content="$options.icons.cilTrash"
                                                    class="cursor-pointer"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </component>
                            </table>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>

            <div class="flex mt-4">
                <CButton
                    color="primary"
                    @click="submit"
                >{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete"
                >Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </AppFormValidator>
</template>

<script>
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';
    import to from 'await-to-js';
    import DatePicker from 'vuejs-datepicker';
    import moment from 'moment';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            DatePicker,
            draggable,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        icons: {
            cilCursorMove,
            cilTrash
        },

        data() {
            return {
                checkReferalProgram: false,
                model: {},
                schema: {
                    id: 'id',
                    type: 'type',
                    title: 'title',
                    description: 'description',
                    background: 'background',
                },
                rules: {
                    type: [requiredRule],
                    title: [requiredRule],
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                canDragable: false,
                variants: [],
                types: [
                    { value: 'single', label: 'Одиночный выбор' },
                    { value: 'multiple', label: 'Множественный выбор' },
                    { value: 'text', label: 'Текст' },
                ]
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        async mounted() {
        },

        created() {
            this.survey_id = this.$route.params.id;
            this.setModel();
        },

        methods: {
            disableEntity(event, code) {
                this.disabledEntities[code] = event.target.checked;
            },
            setModel() {
                this.model = morphism(this.schema, this.entity);
                this.variants = this.entity && this.entity.variants ? JSON.parse(JSON.stringify(this.entity.variants)) : [];
            },
            addVariant() {
                this.variants.push({ title: '' });
            },
            removeVariant(index) {
                this.variants.splice(index, 1);
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;
                let questionId = id;

                if (typeof id === 'number') {
                    const [err] = await to(this.axios.put(`/surveys/${this.survey_id}/questions/${id}`, payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                    }
                    questionId = id;
                } else {
                    const [err, resp] = await to(this.axios.post(`/surveys/${this.survey_id}/questions`, payload));
                    if (err || !resp?.data?.id) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                    }
                    questionId = resp.data.id;
                }

                if (this.entity.variants) {
                    for (const variant of this.entity.variants) {
                        const finded = this.variants.find(item => item.id === variant.id);
                        if(!finded) {
                            await this.axios.delete(`/surveys/${this.survey_id}/questions/${questionId}/variants/${variant.id}`);
                        }
                    }
                }

                let index = 0;
                for (const variant of this.variants) {
                    variant.position = ++index;
                    if (typeof variant.id === 'number') {
                        const [err] = await to(this.axios.put(`/surveys/${this.survey_id}/questions/${questionId}/variants/${variant.id}`, variant));
                        if (err) {
                            return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                        }
                    } else {
                        const [err] = await to(this.axios.post(`/surveys/${this.survey_id}/questions/${questionId}/variants`, variant));
                        if (err) {
                            return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                        }
                    }
                }

                this.$router.push(`/surveys/${this.survey_id}/questions`);
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/surveys/${this.survey_id}/questions/${this.model.id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка удаления записи.');
                }

                this.$emit('deleted');
            },

            async onFileChange(e, field) {
                const file = e.target.files[0];
                if (!file) return;
                const formData = new FormData();
                formData.append('file', file);
                try {
                    const { data } = await this.axios.post('/files/upload', formData);
                    this.$set(this.model, field, data.filename);
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка загрузки файла');
                }
            },
            
            imageUrl(filename) {
                return process.env.VUE_APP_STATIC_BASE_URL + '/' + filename;
            },
        },
    };
</script>
<style>
input.custom-datepicker {
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
</style>
